import { Box, Tooltip } from '@mui/material'
import React, { useMemo } from 'react'

import { TARGET_TYPES } from 'components/attacks/create/targets/target-utils'
import { getServiceIdFromAttack } from 'components/attacks/utils/attack-configuration'
import SquareGlyph from 'components/common/SquareGlyph'
import Icon from 'components/Icon'
import SvgTargets from 'components/icons/Targets'
import { getTargetType } from 'components/scenarios/concurrent/attack-attributes'
import { muiTheme } from 'mui-theme'
import theme from 'theme'

import type { InfraAttackNode } from 'types/api/scenarios/scenario'

export const AttackGraphNodeTargetGlyph: React.FC<{
  node: InfraAttackNode
  showTargetType: boolean
}> = ({ node, showTargetType }) => {
  const serviceId = getServiceIdFromAttack(node)
  const targetType = getTargetType(node)

  const targetTypeDefinition = TARGET_TYPES[targetType]

  const { TargetGlyph, TargetIcon } = useMemo(() => {
    if (showTargetType) {
      return {
        TargetGlyph: serviceId
          ? SquareGlyph
          : targetTypeDefinition.SvgGlyphIcon,
        TargetIcon: serviceId
          ? () => <Icon icon="chartNetwork" />
          : targetTypeDefinition.SvgIcon
      }
    }

    return {
      TargetGlyph: SquareGlyph,
      TargetIcon: SvgTargets
    }
  }, [
    serviceId,
    showTargetType,
    targetTypeDefinition.SvgGlyphIcon,
    targetTypeDefinition.SvgIcon
  ])

  return (
    <Tooltip
      arrow
      describeChild
      placement="top"
      title={serviceId ? 'Service' : targetTypeDefinition.type}
    >
      <Box>
        <TargetGlyph
          backgroundColor={theme.colors.gray[1]}
          css={{ height: 30, width: 30, marginRight: muiTheme.spacing(0.5) }}
        >
          <TargetIcon
            css={{
              fontSize: theme.fontSizes[showTargetType ? 2 : 4],
              color: theme.colors.steel[1]
            }}
          />
        </TargetGlyph>
      </Box>
    </Tooltip>
  )
}
